import './settlements.scss';

import { ReactComponent as Add } from '@basqet-dashboard/common/assets/icons/add.svg';
import { ReactComponent as AddLight } from '@basqet-dashboard/common/assets/icons/add-light.svg';
import { Button, TableWrapper } from '@basqet-dashboard/common/components';
import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import {
  useFetchSettlementAccounts,
  useFetchSettlements
} from '@basqet-dashboard/common/hooks/queries';
import { formatWallet } from '@basqet-dashboard/common/utils';
import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { RequestSettlement } from './request-settlement';

function Settlements() {
  const [showModal, setShowModal] = useState(false);
  const { accounts } = useFetchSettlementAccounts();

  const history = useHistory();
  const hasPermission = useHasPermission();
  const canExportSettlement = hasPermission(PERMISSIONS.SETTLEMENTS_EXPORT);
  const canManageSettlement = hasPermission(PERMISSIONS.SETTLEMENTS_MANAGE);

  const navigateToPage = (destination) => {
    history.push(`/${destination}`);
  };
  const {
    searchQuery,
    setSearchQuery,
    settlements,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    setStatus,
    isLoading,
    filterByDate,
    refetch: refetchSettlements
  } = useFetchSettlements();
  let showIsFetching = (!settlements.length && isLoading) || searchQuery || isRefetching;
  const closeModal = () => {
    setShowModal(false);
  };

  const formattedSettlements = settlements.map((settlement) => {
    const { settlement_account, amount, settlement_amount, currency } = settlement;
    const { slug: currencySlug } = currency;
    const amount_requested = `${amount} ${currencySlug}`;
    const amount_to_be_settled = `${settlement_amount} ${currencySlug}`;
    const settlement_address = formatWallet(settlement_account?.account_address);

    return {
      ...settlement,
      settlement_address,
      amount_requested,
      amount_to_be_settled
    };
  });

  return (
    <>
      <div className="settlements">
        {canManageSettlement && (
          <section className="settlements__intro">
            <h3>Manage Your Settlement Account</h3>
            <p>
              Our payment gateway creates a safe, easy and fast way to do business with customers
              globally.
            </p>
            <div className="settlements__intro__button__group">
              {!!accounts.length && (
                <Button
                  className="settlements__button settlements__button--primary"
                  onClick={() => setShowModal(true)}>
                  <AddLight /> Request for settlement
                </Button>
              )}

              <Button
                className="settlements__button"
                onClick={() => navigateToPage(`settings/settlement`)}>
                <Add /> Add settlement account
              </Button>
            </div>
          </section>
        )}
        <TableWrapper
          data={formattedSettlements}
          title="Recent"
          name="settlements"
          exportData={canExportSettlement}
          onLoadMore={fetchNextPage}
          canLoadMore={hasNextPage}
          hasFilters
          isFetching={showIsFetching}
          isLoading={isFetchingNextPage}
          onSearch={setSearchQuery}
          onStatusChange={setStatus}
          onDateFilter={filterByDate}
          searchPlaceholder="Search for settlement address, amount, currency or reference ID"
        />
      </div>
      {showModal && (
        <RequestSettlement onModalClose={closeModal} refetchSettlements={refetchSettlements} />
      )}
    </>
  );
}

export { Settlements };
